var React = require('react');

function IconExclamation (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M456.414 109.793h118.193c8.126 0 14.774 6.648 14.774 14.774v443.37c0 8.126-6.648 14.774-14.774 14.774H456.414c-8.126 0-14.774-6.648-14.774-14.774v-443.37c0-8.126 6.648-14.774 14.774-14.774zM424.649 767.979c0 50.181 40.68 90.861 90.861 90.861s90.861-40.68 90.861-90.861c0-50.181-40.68-90.861-90.861-90.861s-90.861 40.68-90.861 90.861z"}));
}

IconExclamation.displayName = "IconExclamation";

IconExclamation.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconExclamation;

IconExclamation.default = IconExclamation;
